import { getTaxTimelines } from '@/api/tax/tax-timelines';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { useGetEntitiesV3 } from '../composables/use-get-entities-v3';
import { computed } from 'vue';

export const useTaxTimelinesStore = defineStore('taxTimelines', () => {
  const data = useGetEntitiesV3(getTaxTimelines);

  const entities = computed(() => [...data.entities.value].sort((a, b) => new Date(b.validFrom).getTime() - new Date(a.validFrom).getTime()));

  return {
    ...data,
    entities,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTaxTimelinesStore, import.meta.hot));
}
